import { useQuery } from '@tanstack/react-query';

import type { ExtranetHotelFinance } from 'app/typings/core/extranet/hotel/finance';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelFinance(hotelId?: number) {
  return useQuery<ExtranetHotelFinance>({
    queryKey: [CORE_QUERY_KEYS.hotelFinance, hotelId],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getHotelFinance,
        params: { id: (hotelId as number).toString() },
      }),
    enabled: !!hotelId,
    staleTime: Infinity,
  });
}
